"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "hasRepoChanged", {
    enumerable: true,
    get: function() {
        return hasRepoChanged;
    }
});
const _workspacetools = require("workspace-tools");
const _fastglob = /*#__PURE__*/ _interop_require_wildcard(require("fast-glob"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function hasRepoChanged(since, root, environmentGlob, logger) {
    try {
        const changedFiles = (0, _workspacetools.getBranchChanges)(since, root);
        const envFiles = _fastglob.sync(environmentGlob, {
            cwd: root
        });
        let repoWideChanged = false;
        if (changedFiles) {
            for (const change of changedFiles){
                if (envFiles.includes(change)) {
                    repoWideChanged = true;
                    break;
                }
            }
        }
        return repoWideChanged;
    } catch (e) {
        // if this fails, let's assume repo has changed
        logger.warn(`An error in the git command has caused this to consider the repo has changed\n${e}`);
        return true;
    }
}
